import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/VerifyOTP.css";
import loginImg from "../../assets/loginImage.jpeg";
import Navbar from "../../layouts/Navbar";
import Loader from "../../components/common/Loading";
import axios from "axios";
import logo from "../../assets/Logo.png";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import { Link } from "react-router-dom";

function ProviderVerifyOTP() {
  const otpRef = useRef([]);
  const [otp, setOtp] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Check if OTP is empty
    if (!otp || otp.length !== 4) {
      toast.error("Please enter OTP");
      return;
    }
    //console.logotp);
    var enteredOtp = "";
    otp.map((val) => {
      enteredOtp += val;
    });
    try {
      setLoading(true); // Start loading
      const response = await axios.post(
        "https://yelospace.com/api/provider/verify-otp",
        { email: email, otp: enteredOtp }
      );
      //console.logresponse.data);
      if (response.data.status === 200) {
        // Redirect to appropriate page upon successful OTP verification
        localStorage.setItem("otp", enteredOtp);

        navigate("/provider-reset-password");
      } else {
        toast.error("Invalid OTP");
        console.error("OTP verification failed");
      }
    } catch (error) {
      console.error("Error occurred:", error);
    } finally {
      setLoading(false); // Finish loading
    }
  };
  const enterOtp = (e, otpNumber) => {
    const no = e.target.value;
    if (!no || no?.length <= 1) {
      const currentOtp = [...otp];
      currentOtp[otpNumber] = no;
      setOtp(currentOtp);
      if (no && otpRef.current[otpNumber + 1]) {
        otpRef.current[otpNumber + 1].focus();
      }
      if (!no && otpRef.current[otpNumber - 1]) {
        otpRef.current[otpNumber - 1].focus();
      }
    }
    if (no?.length === 4 && otpNumber === 0 && !isNaN(no)) {
      setOtp(no.toString().split("").map(Number));
      otpRef.current[3].focus();
    }
  };
  useEffect(() => {
    const username = localStorage.getItem("email");
    setEmail(username);
  }, []);
  return (
    <>
      {/* <Navbar /> */}
      <ToastContainer/>
   
      {loading ? (
        <Loader className="d-flex justify-content-center align-items-center" />
      ) : (
        <div className="verify-otp-container">
        
          {/* <ToastContainer /> */}
          <div className="left-panel">
          <div className="w-100 d-flex justify-content-center">
            <img src={loginImg} alt="Left Panel Image" />
          
          </div>
          </div>
          <div className="right">
          <div className="w-100 d-flex justify-content-center">
              <Link to="/">
                <img src={logo} className="logo-img" alt="Left Panel Image" />
              </Link>
            </div>
            <form onSubmit={handleSubmit}>
            <div className="w-100 d-flex justify-content-center">
              <h3 style={{}}>Enter OTP sent on your registered email</h3>
              </div>
              <div className="otp-inputs">
                <input
                  ref={(el) => (otpRef.current[0] = el)}
                  value={otp[0]}
                  type="number"
                  onInput={(e) => enterOtp(e, 0)}
                />
                <input
                  ref={(el) => (otpRef.current[1] = el)}
                  value={otp[1]}
                  type="number"
                  onInput={(e) => enterOtp(e, 1)}
                />
                <input
                  ref={(el) => (otpRef.current[2] = el)}
                  value={otp[2]}
                  type="number"
                  onInput={(e) => enterOtp(e, 2)}
                />
                <input
                  ref={(el) => (otpRef.current[3] = el)}
                  value={otp[3]}
                  type="number"
                  onInput={(e) => enterOtp(e, 3)}
                />
              </div>
              <div className="d-flex justify-content-center w-100">
                <button type="submit" className="submit-btn mt-3">
                  Verify OTP
                </button>
              </div>
            </form>
            <div className="w-100 d-flex justify-content-center">
            <div className="back-to-login">
              <a href="/provider-login">
                Back to{" "}
                <span style={{ textDecoration: "underline" }}>Login </span>{" "}
              </a>
            </div>
          </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ProviderVerifyOTP;
